import { Component, OnInit } from "@angular/core";
import { BreadcrumbService } from "app/breadcrumb.service";
import { AppServiceManager } from "common/services/appServiceManager";
import { MessageService, ConfirmationService } from "primeng/api";
import { AuthService } from "common/services/auth.service";
import { IUser } from "app/shared/Domains/IUser";
import { IRole } from "app/shared/Domains/role";
import { ISubscriptionFee } from "app/services/models/subscriptionFee";
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
    selector: "app-trainer-dashboard",
    templateUrl: "./trainer-dashboard.component.html",
    styleUrls: ["./trainer-dashboard.component.css"],
})
export class TrainerDashboardComponent implements OnInit {
    loading: boolean;
    user: IUser;
    role: IRole;
    trainer: IUser;
    trainingSessions: any[];
    trainingSessionsFiltered: any[];
    allTrainingSessions: any[];
    allSubscriptions: any[];
    allSubscriptionsFee: any[];
    customers:any[];
    subscribers:any[];
    trainingSessionsDialog: boolean=false;
    sessionsDialog: boolean = false;
    sessionId: string;
    presentClicked: boolean;
    rescheduleClicked: boolean;
    totalTrainerShare = 0;
    trainerAllSubscriptionsFee: ISubscriptionFee[];
    totalTrainerExpanses = 0;
    trainerExpanses = [];
    totalTrainerBorrowed = 0;
    trainerBorrowing = [];
    classSessionsDialog: boolean = false;
    members: any[];
      yearOptions: any[] = [];
      monthOptions: any[] = [];
      monthValue: string;
      yearValue: string;
    constructor(
        private LanguageService: LanguageService,
        private messageService: MessageService,
        private breadcrumbService: BreadcrumbService,
        private appServiceManager: AppServiceManager,
        private ConfirmationService: ConfirmationService,
    ) {
    }

    ngOnInit() {
        const currentYear = new Date().getFullYear();
        const startYear = currentYear - 5;
        const endYear = currentYear;
        this.yearOptions = [];
        for (let year = startYear; year <= endYear; year++) {
            this.yearOptions.push({ label: year.toString(), value: year.toString() });
        }
        this.monthOptions = [
            { label: "January", value: '1' },
            { label: "February", value: '2' },
            { label: "March", value: '3' },
            { label: "April", value: '4' },
            { label: "May", value: '5' },
            { label: "June", value: '6' },
            { label: "July", value: '7' },
            { label: "August", value: '8' },
            { label: "September", value: '9' },
            { label: "October", value: '10' },
            { label: "November", value: '11' },
            { label: "December", value: '12' }
        ];

        this.loading = false;
        this.trainer = new IUser;
        this.user = AuthService.getLoggedInUser();
        this.role = AuthService.getLoggedInRole();
        this.getUser();
        this.getTodaysSessions();
        this.getAllSession();
        this.getAllSubscriptions();
        this.breadcrumbService.setItems([
            { label: 'Trainer Dashboard', routerLink: '/trainer-dashboard' },
        ]);
        const dateNow = new Date();
        this.monthValue = (dateNow.getMonth() + 1).toString();
        this.yearValue = currentYear.toString();
    }
    setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("TrainerDashboardComponent", label);
      }
      onMonthOrYearChange(): void {
        this.getTrainerSubscriptionsFees();
        this.getTrainerBorrowing();
        this.getTrainerExpanses();
        this.getCustomers();
    }
    getUser(){
        this.allTrainingSessions = [];
        this.loading = true;
        let url;
        url = `branches/${AuthService.getLoggedInBranch() || this.user.branch}/users/${this.user._id}`;
        this.appServiceManager
            .get(
                url
            )
            .subscribe(
                (res) => {
                    if (res) {
                        this.trainer = res;
                        this.getTrainerSubscriptionsFees();
                        this.getTrainerExpanses();
                        this.getTrainerBorrowing();
                    } else {
                        this.trainer = new IUser;
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "No Record Found",
                        });
                    }
                    this.loading = false;
                },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }
    getTrainerSubscriptionsFees() {
        this.loading = true;
        const url = `branches/${this.user.branch}/subscription-fees/trainers/${this.user._id}?month=${this.monthValue}&year=${this.yearValue}`;
        this.appServiceManager.get(url).subscribe(
            (res) => {
                if (res) {
                    this.trainerAllSubscriptionsFee = res.response;
                    let total = 0;
                    this.trainerAllSubscriptionsFee.forEach(fee => {
                        const trainerPackages = this.trainer.fees.filter(t => t._id === fee.trainerPackageId)[0];
                        const trainerShare = 100 - trainerPackages.gymSharePercentage;
                        const totalFee = parseInt(fee.pay) - parseInt(fee.discount);
                        total += ((totalFee * trainerShare) / 100);
                    });
                    this.totalTrainerShare = total;
                    this.loading = false;
                } else {
                    this.loading = false;
                }
            },
            (error) => {
                this.loading = false;
                console.log(error);
            }
        );
    }

    getTrainerExpanses() {
        this.loading = true;
        const branchId = AuthService.getLoggedInBranch() || this.user.branch;
        const url = `branches/${branchId}/petty-expenses/trainers/${this.user._id}/reports/expenses?month=${this.monthValue}&year=${this.yearValue}`;
        this.appServiceManager.get(url).subscribe(
            (res) => {
                if (res) {
                    this.trainerExpanses = Array.isArray(res) ? res : (res?.response ?? []);
                    this.getTotalExpanses();
                }
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                console.log(error);
            }
        );
    }
    getTrainerBorrowing() {
        this.loading = true;
        const branchId = AuthService.getLoggedInBranch() || this.user.branch;
        const url = `branches/${branchId}/petty-expenses/trainers/${this.user._id}/reports/borrowings?month=${this.monthValue}&year=${this.yearValue}`;
        this.appServiceManager.get(url).subscribe(
          (res) => {
            if (res) {
              this.trainerBorrowing = Array.isArray(res) ? res : (res?.response ?? []);
              this.getTotalBorrowing();
            }
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            console.log(error);
          }
        );
      }

    getTotalExpanses() {
        if(this.trainerExpanses.length == 0) {
            this.totalTrainerExpanses = 0;
            return;
        }
        this.trainerExpanses.forEach(e => {
            this.totalTrainerExpanses += parseInt(e.amount);
            });
    }
    getTotalBorrowing() {
        this.totalTrainerBorrowed = 0; // Reset the total before summing up
        if(this.trainerBorrowing.length == 0) {
          this.totalTrainerBorrowed = 0;
          return;
        }
        this.trainerBorrowing.forEach(e => {
          this.totalTrainerBorrowed += parseInt(e.amount);
        });
      }
    getAllSession(){
        this.allTrainingSessions = [];
        this.loading = true;
        let url;
        url = `branches/${this.user.branch}/training-sessions/actions/all?trainerId=${this.user._id}`;
        this.appServiceManager
            .get(
                url
            )
            .subscribe(
                (res) => {
                    if (res.length > 0) {
                        this.allTrainingSessions = res;
                    } else {
                        this.allTrainingSessions = [];
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "No Record Found",
                        });
                    }
                    this.loading = false;
                },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }
    getAllSubscriptions(){
        this.allSubscriptions = [];
        this.loading = true;
        let url;
        url = `branches/${this.user.branch}/subscriptions/trainers/${this.user._id}`;
        this.appServiceManager
            .get(
                url
            )
            .subscribe(
                (res) => {
                    if (res.response.length > 0) {
                        this.allSubscriptions = res.response;
                        this.getAllSubscriptionsFee()
                    } else {
                        this.allSubscriptions = [];
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "No Record Found",
                        });
                    }
                    this.loading = false;
                },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }
    getAllSubscriptionsFee(){
        this.allSubscriptionsFee = [];
        this.loading = true;
        let url;
        url = `branches/${this.user.branch}/subscription-fees/trainers/${this.user._id}`;
        this.appServiceManager
            .get(
                url
            )
            .subscribe(
                (res) => {
                    if (res.response.length > 0) {
                        this.allSubscriptionsFee = res.response;
                        this.getCustomers();
                    } else {
                        this.allSubscriptionsFee = [];
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "No Record Found",
                        });
                    }
                    this.loading = false;
                },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }
    getTodaysSessions(){
        this.trainingSessions = [];
        this.loading = true;
        let url;
        url = `branches/${this.user.branch}/training-sessions/reports/today?trainerId=${this.user._id}`;
        this.appServiceManager
            .get(
                url
            )
            .subscribe(
                (res) => {
                    if (res.length > 0) {
                        this.trainingSessions = res;
                        this.trainingSessionsFiltered=this.trainingSessions.filter(session=>{
                            return session.trainingType != "classTraining"
                        })
                    } else {
                        this.trainingSessions = [];
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "No Record Found",
                        });
                    }
                    this.loading = false;
                },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }
    changeAttendedStatus(member) {
        member.attendedStatus = member.attendedStatus === 'ATTENDED' ? 'UNMARKED' : 'ATTENDED';
    }
    openClassAttendanceDialog(classSession){
        let todayDate = new Date();
        this.members = this.trainingSessions
                .filter(session => {
                    const sessionStartDate = new Date(session.startDate);
                    const sessionStartDateOnly = new Date(sessionStartDate.getFullYear(), sessionStartDate.getMonth(), sessionStartDate.getDate());
                    const todayDateOnly = new Date(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate());
                    return session.trainerPackageId === classSession.trainerPackageId &&
                        sessionStartDateOnly.getTime() === todayDateOnly.getTime();
                })
                .map(session => {
                    return { id: session._id, name: session.subscriberName, attendedStatus: session.status };
                });
            this.members = this.members.filter(member => member.name !== undefined)
        this.classSessionsDialog = true;
    }
    markClassAttendance(){
        for(let member of this.members){
            if (member.attendedStatus === "UNMARKED") {
                member.attendedStatus = "NO–SHOW";
            }
        }
        const url = `branches/${this.user.branch}/training-sessions/actions/mark-class-attendance`;
        const body = { members: this.members.map((m: any) => ({ id: m.id, attendedStatus: m.attendedStatus })) };
        this.appServiceManager.put(url, body).subscribe((res: any) => {
            this.classSessionsDialog = false;
            this.getTodaysSessions();
        },
            (error) => {
                console.error('Attendance failed', error);
            }
        );
    }
    hideModal() {
        this.classSessionsDialog = false;

    }
    getCustomers(){
        this.customers = [];
        this.subscribers = [];
        let customersMap = {};
        const expiredSubscribersMap = {};
        const activeSubscribersMap = {};
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        this.allSubscriptions.forEach(subscription => {
            const dueDate = subscription?.dueDate ? new Date(subscription.dueDate) : null;
            if (dueDate && !isNaN(dueDate.getTime())) {
                dueDate.setHours(0, 0, 0, 0);
                if (dueDate < today) {
                    expiredSubscribersMap[subscription.subscriberId] = true;
                } else {
                    activeSubscribersMap[subscription.subscriberId] = true;
                }
            }
            if (!customersMap[subscription.subscriberId]) {
                customersMap[subscription.subscriberId] = {
                    subscriberId: subscription.subscriberId,
                    trainerPackageId: subscription.trainerPackageId,
                    totalSessions: 0,
                    totalSubscriptions: 0
                };
            }
            customersMap[subscription.subscriberId].totalSessions += subscription.numberOfSessions;
            customersMap[subscription.subscriberId].totalSubscriptions += 1;
        });
        let subscribersMap = {};
        this.allSubscriptionsFee.forEach(fee => {
            const feeDate = new Date(fee.date);
            if (
                feeDate.getMonth() + 1 === parseInt(this.monthValue) &&
                feeDate.getFullYear() === parseInt(this.yearValue)
            ) {
                if (!subscribersMap[fee.subscriberId]) {
                    subscribersMap[fee.subscriberId] = {
                        subscriberId: fee.subscriberId,
                        subscriberName: fee.subscriberName,
                        subscriberMembership: fee.subscriberMembership,
                        totalPay: 0
                    };
                }
                subscribersMap[fee.subscriberId].totalPay += (parseInt(fee.pay) - parseInt(fee.discount));
            }
        });

        this.subscribers = Object.values(subscribersMap);
        let combinedData = [];
        this.subscribers.forEach(subscriber => {
            let customer = customersMap[subscriber.subscriberId];
            if (customer) {
                combinedData.push({
                    subscriberId: subscriber.subscriberId,
                    subscriberName: subscriber.subscriberName,
                    subscriberMembership: subscriber.subscriberMembership,
                    totalPay: subscriber.totalPay,
                    trainerPackageId: customer.trainerPackageId,
                    totalSessions: customer.totalSessions,
                    totalSubscriptions: customer.totalSubscriptions,
                    totalAttendedSessions: 0,
                    totalMissedSessions: 0,
                    hasExpiredSubscription: !!expiredSubscribersMap[subscriber.subscriberId] && !activeSubscribersMap[subscriber.subscriberId]
                });
            }
        });

        combinedData.forEach(subscriber => {
            let attendedSessions = 0;
            let missedSessions = 0;

            this.allTrainingSessions.forEach(session => {
                if (session.subscriberId === subscriber.subscriberId) {
                    if (session.status == "ATTENDED") {
                        attendedSessions++;
                    } else if (session.status == "NO–SHOW") {
                        missedSessions++;
                    }
                }
            });

            subscriber.totalAttendedSessions = attendedSessions;
            subscriber.totalMissedSessions = missedSessions;
        });

        this.customers = combinedData;
        this.customers.forEach(customer => {
            if (customer.trainerPackageId) {
                let trainerFee = this.trainer.fees.find(fee => fee._id == customer.trainerPackageId);
                if (trainerFee) {
                    let trainerSharePerct = 100 - trainerFee.gymSharePercentage;
                    customer.trainershare = parseInt(customer.totalPay) * trainerSharePerct / 100;
                } else {
                    customer.trainershare = 0;
                }
            } else {
                customer.trainershare = 0;
            }
        });
    }
    markPresent(session){
        this.sessionsDialog=true;
        this.sessionId = session._id;
        this.presentClicked=true;
        this.rescheduleClicked=false;
    }
    reschedule(session){
        this.sessionsDialog=true;
        this.sessionId = session._id;
        this.presentClicked=false;
        this.rescheduleClicked=true;
    }
    markAbsent(session) {
        this.ConfirmationService.confirm({
          message: 'Are you sure you want to mark this session as absent?',
          accept: () => {
            const url = `branches/${this.user.branch}/training-sessions/${session._id}/actions/mark-absent`;
            const body = {  status: "NO–SHOW" };
            this.appServiceManager.put(url, body).subscribe((res: any) => {
              this.trainingSessionsDialog = false;
              this.getTodaysSessions();
            }, error => {
              console.error('Attendance failed', error);
            });
          }
        });
      }
    closeTrainingSessionsDialog() {
        this.getTodaysSessions();
        this.sessionsDialog = false;
    }

    handleChange(event){
        if(event.index==1){
            //this.getCustomers();
        }
    }
}
